import React from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';
import { INTERFACE } from 'pathnames.js';
import { SORT_ORDER } from 'globals.js';

// GLOBAL HELPERS
import { getListData } from 'helpers/getListData';

// PARTS
import Main from 'parts/main/Main';
import Table, { Filters } from 'parts/table/Table.js';
import Title from 'parts/title/Title';

// LOCAL VARIABLES
import { INVENTORY_TYPE } from './codes.js';
import { COLUMNS as INVENTORY_COLUMNS } from './columns.js';
import { ACTIONS, COLUMNS } from 'columns.js';

// LOCAL COMPONENTS
import ExcelButtons from 'routers/interface/tools/ExcelButtons.js';

// VARIABLES
const LOOKUP_PARAMS = {
  inventoryStatus: {
    inventoryType: INVENTORY_TYPE.funded.code
  },
  inventorySource: {
    listPage: '1'
  }
};

// MAIN COMPONENT
const Funded = () => (
  <Main>
    <Title documentTitle="Inventory -> Funded " title="Funded" tools={<ExcelButtons fileName="inventory_funded" />} />
    <Filters>
      <Filters.Button.SalesType />
      <Filters.Button.NewUsed />
      <Filters.Select.InventoryStatus lookupParams={LOOKUP_PARAMS.inventoryStatus} />
      <Filters.Select.InventorySource lookupParams={LOOKUP_PARAMS.inventorySource} />
      <Filters.Search />
      <Table.Columns />
    </Filters>
    <Table mobilePreviewKeys={['stock_num', 'purchase_date', 'make_model']} showNumber />
  </Main>
);

// EXPORT
export default getListData(Funded, {
  key: 'inventoryFunded',
  fetchArgs: {
    endpoint: ENDPOINTS.inventory.list,
    params: {
      inventoryType: INVENTORY_TYPE.funded.code
    }
  },
  defaults: {
    sort: 'purchase_date',
    order: SORT_ORDER.descending
  },
  columns: [
    INVENTORY_COLUMNS.purchasedDate,
    INVENTORY_COLUMNS.retailWholesale,
    COLUMNS.fundedDate,
    COLUMNS.inventorySource,
    INVENTORY_COLUMNS.age,
    COLUMNS.newUsed,
    COLUMNS.stockNumber,
    COLUMNS.makeModel,
    COLUMNS.mileage,
    COLUMNS.acv,
    COLUMNS.dmsInvoice,
    COLUMNS.inventoryStatus,
    INVENTORY_COLUMNS.location,
    INVENTORY_COLUMNS.warranty,
    INVENTORY_COLUMNS.key,
    INVENTORY_COLUMNS.spareKey,
    INVENTORY_COLUMNS.homenet,
    INVENTORY_COLUMNS.detail,
    INVENTORY_COLUMNS.inspection,
    INVENTORY_COLUMNS.emission,
    INVENTORY_COLUMNS.picture,
    INVENTORY_COLUMNS.miscellaneous
  ],
  actions: [ACTIONS.open(INTERFACE.inventory, 'daily_sales_inventory_id')],
  filterColumns: true,
  sortable: true
});
